import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Processbar } from '@core/Processbar';
import { Outlet } from 'react-router-dom';
import { Footer } from '@core';
import { useActivation } from '@context/MobileOne';
import { CancelRegistrationPopup } from './CancelRegistrationPopup';

export function ActivationLayout() {
  const location = useLocation();

  const {
    showActivationHeader,
    setShowActivationHeader,
    showActivationFooter
    // handleCancelButtonClick
  } = useActivation();

  useEffect(() => {
    // Should be done in combination with setting initial state showActivationHeader as true in each step
    if (location.pathname !== '/activation') {
      setShowActivationHeader(false);
    }

    // UNCOMMENT if needed
    // This will completely reset activation on browser's back button
    // if (location.pathname !== '/activation') {
    //   handleCancelButtonClick();
    // }
  }, [location.pathname, setShowActivationHeader, showActivationHeader]);

  return (
    <>
      {showActivationHeader && <Processbar />}
      <CancelRegistrationPopup />
      <main className="flex-grow-1">
        <Outlet />
      </main>
      {showActivationFooter && <Footer />}
    </>
  );
}

export default ActivationLayout;
